import { gql } from '@apollo/client';
import { useGraphql } from 'utils/hooks/useGraphql';
import { AnonUserCriteria } from 'modules/graphql/types/GraphQLAnonymousCriteria';
import { AnonCriteriaFragment } from '../constants';

type CriteriaResult = {
  anonUserCriteria: { payload: AnonUserCriteria };
};

export const getAnonUserCriteriaByIdQuery = gql`
  query getAnonUserCriteriaById($id: Long!) {
    anonUserCriteria(id: $id) {
      payload {
        ...AnonCriteria
      }
    }
  }
  ${AnonCriteriaFragment}
`;

export const fetchIsSdkSetupWorkingQuery = gql`
  query isSdkSetupWorking {
    getIsSdkSetupWorking
  }
`;

export const useQueryAnonCriteria = (id: number) => {
  const { data, isLoading, error, refetch } = useGraphql<CriteriaResult>(
    getAnonUserCriteriaByIdQuery,
    {
      skip: !id,
      variables: {
        id,
      },
    },
  );

  return {
    criteria: data?.anonUserCriteria?.payload,
    loading: isLoading,
    error,
    refetch,
  };
};

export const useQueryIsSdkSetupWorking = () => {
  const { data } = useGraphql(fetchIsSdkSetupWorkingQuery);
  return {
    isSdkSetupWorking: data?.getIsSdkSetupWorking ?? true,
  };
};
